// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"395":"f66b1098","901":"c6df8d85"}[chunkId] + ".chunk.js";
};